import { render, staticRenderFns } from "./AddAssignmentWrapper.vue?vue&type=template&id=555ed18c&scoped=true&"
import script from "./AddAssignmentWrapper.vue?vue&type=script&lang=js&"
export * from "./AddAssignmentWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AddAssignmentWrapper.vue?vue&type=style&index=0&id=555ed18c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555ed18c",
  null
  
)

export default component.exports